import React, { useState } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../components/icon/iconfont";
import { BlackMask } from "../../../../../components/mask";
import BottomToTop from "../../../../../components/transitions/bottom-to-top";
import ReactDOM from 'react-dom';
import { FormattedMessage } from "react-intl";

const LocationSub = props =>{
	const { location, onSelect, currenyLocation } = props;

	return <a onClick={()=>onSelect(location)} className={`${cls.LocationSub} ${location?.value === currenyLocation?.value ? cls.Active: ""}`}>
		<span>{location?.value} </span>
		<span>+{location?.areaCode}</span>
	</a>
}

const SelectLocationEditor = props =>{
	const { locations, currenyLocation, onClose, onSelect } = props;

	return <div className={cls.SelectLocationEditor}>
		<div className={cls.SelectLocationHd}>
			<span className={cls.Font}><FormattedMessage id="please_select_location" defaultMessage="Please select your location" /></span>

			<Iconfont className={cls.CloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>
		</div>

		 <div className={cls.SelectLocationBd}>
			<div className={cls.SelectLocationList}>
				{
					locations.map((location, index)=>(
						<LocationSub key={location+index} onSelect={onSelect} location={location} currenyLocation={currenyLocation} />
					))
				}
			</div>
		 </div>
	</div>
}

const WrappedEditor = props => {
    useStyles(cls);
    const { show, onClose } = props; 

	return <React.Fragment>
		<BottomToTop in={show} className={cls. SelectLocationContainer}>
			<div>
				<SelectLocationEditor {...props} />
			</div>
		</BottomToTop>
		{show && <BlackMask onClick={onClose} style={{ backgroundColor: 'rgba(0, 0, 0, 0)', zIndex: 11 }} />}
	</React.Fragment>
}

const SelectLocationWrapped = props =>{

	if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}



export default props => {
	const { locations, currenyLocation, onSelect } = props;
	const [showModal, setShowModal] = useState(false);

	return <React.Fragment>
		<div onClick={()=>setShowModal(true)} className={cls.SelectFont}>
			<span className={cls.Font}>{currenyLocation?.value} +{currenyLocation?.areaCode}</span>
			<Iconfont className={cls.Icon}>&#xe7e2;</Iconfont>
		</div>

		<SelectLocationWrapped 
			show={showModal} 
			onClose={()=>setShowModal(false)} 
			currenyLocation={currenyLocation} 
			onSelect={(location) =>{
				onSelect(location);
				setShowModal(false)
			}} 
			locations={locations} 
		/>
	</React.Fragment>
}

